import React, { ReactElement } from 'react';

import ToolbarPopupTool from '../../../ToolbarPopupTool';
import TagsToolbarPopup from './TagsToolbarPopup';

import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';

type Props = {
    selectedElements: Immutable.List<ImMNElement>;
    name: string;
};

const TagsTool = (props: Props): ReactElement => {
    return (
        <ToolbarPopupTool
            {...props}
            popupId={PopupIds.TAGS_TOOL}
            toolName={'tag'}
            buttonSelector=".TagTool .icon"
            PopupComponent={TagsToolbarPopup}
        />
    );
};

export default TagsTool;
